import { createAction } from "redux-act";

export const setSettings = createAction<any>();
export const setRoute = createAction<any>();
export const sidebarHandler = createAction<number>();
